import { CaseValidation } from 'containers/pages/cases/types';
import { validateTitle, validateStatusId } from 'containers/pages/cases/libs/validateCase';

type SetValidFn = (fn: (prev: CaseValidation) => CaseValidation) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DispatchFn = (action: { type: string; payload: any }) => void;

function handleCaseField(
	e: { target: { name: string; value: string } },
	dispatch: DispatchFn,
	setValid: SetValidFn,
) {
	const name = e.target.name.trim();
	const value = e.target.value;

	dispatch({ type: name, payload: value });

	switch (name) {
		case 'Title':
			setValid((prev) => ({ ...prev, Title: validateTitle(value) }));
			break;
		case 'StatusId':
			setValid((prev) => ({ ...prev, StatusId: validateStatusId(value) }));
			break;
		default:
			break;
	}
}

export default handleCaseField;
